import Axios from 'axios'
const reportPanicService = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.RESULTS_BASE_URL
    return AxiosInstance
  },
  getPanicReport(data) {
    return this.axios().get(
      'panic/report?' + 'startDate=' + data.releaseDateStart + '&endDate=' + data.releaseDateEnd + '&status=' + data.status + '&type=' + data.exportWay,
      { responseType: 'arraybuffer' }
    )
  }
}
export default reportPanicService
